import classNames from "classnames";
import React from "react";

interface IRadioButtonOption {
  id: string;
  label: string;
  disabled?: boolean;
}

interface IRadioButtonGroupProps {
  options: IRadioButtonOption[];
  label?: string;
  selectedId?: string;
  onClickHandler: (id: string) => void;
}

const RadioButtonGroup: React.FC<IRadioButtonGroupProps> = ({ options, label, selectedId, onClickHandler }) => {
  return (
    <div className="radio-buttons">
      {label && <div className="radio-buttons__label radio-buttons__label--long">{label}</div>}
      {options.map((option) => (
        <div className="radio-button" key={option.id}>
          <div
            className={classNames("radio-button__click-field", {
              "radio-button__click-field--is-disabled": option.disabled,
            })}
            onClick={() => onClickHandler(option.id)}
          >
            <div
              className={classNames("radio-button__circle", "center", {
                "radio-button__circle--is-selected": selectedId === option.id,
                "radio-button__circle--is-disabled": option.disabled,
              })}
            >
              <div
                className={classNames("radio-button__inner-circle", {
                  "radio-button__inner-circle--is-selected": selectedId === option.id,
                  "radio-button__inner-circle--is-disabled": option.disabled,
                })}
              ></div>
            </div>
            <div
              className={classNames("radio-button__label", "label", {
                "label--is-disabled": option.disabled,
              })}
            >
              {option.label}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export { IRadioButtonGroupProps };
export default RadioButtonGroup;
